
import { Component, Prop, Vue } from "vue-property-decorator";

type Filters = {
    year: boolean | { name: string };
};

@Component({
    components: {},
})
export default class FilterHeader extends Vue {
    @Prop() filterStore!: any;
    @Prop({ default: { year: true } }) filters!: Filters;

    get generateYears() {
        let currentYear = new Date().getFullYear();
        let years = [];

        for (let year = currentYear; year >= 1940; year--) {
            years.push(year);
        }

        return years;
    }

    setFilterAfterYear(e: any) {
        this.filterStore.afterYear = parseInt(e.target.value);
    }

    setFilterBeforeYear(e: any) {
        this.filterStore.beforeYear = parseInt(e.target.value);
    }
}
